import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useOnceSearchParams = () => {
  const [searchParams] = useSearchParams();
  const hspId = searchParams.get('hspId');
  const mpiKey = searchParams.get('mpiKey');

  return { hspId, mpiKey };
};
